module.exports = __webpack_public_path__ + "static/media/whatsappLogo.00be7b70.png";